import { ReactElement } from "react";

import { Entity } from "../api";
import EntityFormFullPage from "./EntityFormFullPage";

type Props = {
  entity: Entity;
};

const EntityEdit = ({ entity }: Props): ReactElement => {
  return (
    <EntityFormFullPage
      entity={entity}
      entityClass={{ id: entity.entityClassId, name: entity.className }}
    />
  );
};

export default EntityEdit;
